/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Algorithm_Study_Field_Not_In_ListInputs */

const en_matching_score_algorithm_study_field_not_in_list = /** @type {(inputs: Matching_Score_Algorithm_Study_Field_Not_In_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Study field not in preferred list`)
};

const de_matching_score_algorithm_study_field_not_in_list = /** @type {(inputs: Matching_Score_Algorithm_Study_Field_Not_In_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studienfach nicht in der bevorzugten Liste`)
};

/**
* | output |
* | --- |
* | "Study field not in preferred list" |
*
* @param {Matching_Score_Algorithm_Study_Field_Not_In_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_algorithm_study_field_not_in_list = /** @type {((inputs?: Matching_Score_Algorithm_Study_Field_Not_In_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Algorithm_Study_Field_Not_In_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_algorithm_study_field_not_in_list(inputs)
	return en_matching_score_algorithm_study_field_not_in_list(inputs)
});